import { EventType } from '@graphql/generated';
import { useFeatureValue } from '@shared/core/featureFlags';
import { useMemo } from 'react';

/**
 * Returns event types for filters by enableBabyRegistry feature flag
 */
export function useEventTypeFilters() {
  const enableBabyRegistry = useFeatureValue('enableBabyRegistry');
  const eventTypes = useMemo(() => (enableBabyRegistry ? [EventType.wedding, EventType.babyRegistry] : [EventType.wedding]), [enableBabyRegistry]);
  return { filterEventTypes: eventTypes };
}
